import React from 'react';
import { withRouter } from 'react-router';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useStore } from 'hooks';
import { MAILING_STATUS, VALIDATION } from 'helpers/constants';
import { Button, ButtonClose } from 'components/ui/form';
import { Input, Select } from 'components/ui/formik';
import { ContactService } from 'services';
import styles from './contact.module.scss';

const ContactValidationSchema = Yup.object().shape({
  name: Yup.string()
    .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
    .required(...VALIDATION.REQUIRED),
  position: Yup.string()
    .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
    .required(...VALIDATION.REQUIRED),
  phone: Yup.string()
    .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
    .test(...VALIDATION.PHONE)
    .required(...VALIDATION.REQUIRED),
  email: Yup.string()
    .max(...VALIDATION.MAX(255, VALIDATION.MAX_STRING))
    .email(...VALIDATION.EMAIL)
    .required(...VALIDATION.REQUIRED),
});

const Contact = ({ edit, onClose }) => {
  const { setUser, setLoading } = useStore();

  const initialValues = {
    name: edit ? edit.name : '',
    position: edit ? edit.position : '',
    phone: edit ? edit.phone : '',
    email: edit ? edit.email : '',
    isMailing: edit ? Number(edit.isMailing) : 0,
  };

  const onSubmit = async (values) => {
    const contactService = new ContactService({ setUser });
    setLoading(true);

    if (edit) {
      await contactService.updateContact(edit.id, { ...values });
    } else {
      await contactService.createContact({ ...values });
    }

    setLoading(false);
    onClose(true);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={ContactValidationSchema}
      onSubmit={onSubmit}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit} className={styles.contact} autoComplete="off">
          <div className={styles.main}>
            <div className={styles.title}>
              {`${edit ? 'Редактирование' : 'Добавление'} `}
              контакта
            </div>
            <div className={styles.fields}>
              <div className={styles.field}>
                <Input label="ФИО" placeholder="Фамилия, Имя и Отчество" name="name" />
              </div>
              <div className={styles.field}>
                <Input label="Должность" placeholder="Введите должность" name="position" />
              </div>
              <div className={styles.field}>
                <Input label="Телефон" placeholder="+375_________" name="phone" />
              </div>
              <div className={styles.field}>
                <Input label="E-mail" placeholder="example@site.com" name="email" />
              </div>
              <div className={styles.field}>
                <Select label="Включить в рассылку?" name="isMailing">
                  {[MAILING_STATUS.CANCEL, MAILING_STATUS.APPROVE].map(value => (
                    <option value={value} key={value}>{MAILING_STATUS.toString(value)}</option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className={styles.buttons}>
            <div>
              <Button type="submit">{edit ? 'Редактировать' : 'Добавить'}</Button>
            </div>
            <div>
              <ButtonClose onClick={() => onClose(false)}>{edit ? 'Закрыть' : 'Отменить'}</ButtonClose>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default withRouter(Contact);
